import React, { useRef, useState } from 'react';

import SwiperCore, { Navigation, Autoplay, EffectCoverflow, Pagination } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/effect-coverflow/effect-coverflow.scss';
import 'swiper/components/pagination/pagination.scss';

import './carousel-item.scss'
import { S3Image } from 'aws-amplify-react';
import { v4 as uuid } from 'uuid';

SwiperCore.use([Navigation, Autoplay, EffectCoverflow, Pagination]);

const Picture = ({ image, compact, s3IdentityId }) => {
    const className = 'my-2 ' + compact ? 'carousel-picture-compact' : 'carousel-picture'
    if (image.url) {
        return <img className={className} src={image.url} alt="" />
    } else if (image.s3Key) {
        return <S3Image level="protected" 
            identityId={s3IdentityId}
            imgKey={image.s3Key} 
            className={className} />
    }
}

const CarouselCard = ({ title, image, index, onTitleChange, onImageChange, readonly, compact, s3IdentityId }) => {
    const titleInput = useRef(null)
    const inputFile = useRef(null)
    const [uploaded, setUploaded] = useState(image)

    React.useEffect(() => {
        titleInput.current.value = title
    }, [titleInput, title, image]);

    return (
        <div className="card carousel-card is-rounded">
            <header className="card-header is-shadowless px-1">
                <p className="card-header-title pl-1 px-1 py-1">
                    <input
                        className={`input carousel-input is-shadowless is-size-6 pt-1 pb-0 ${readonly ? '' : 'carousel-input-editor'}`}
                        readOnly={readonly}
                        type="text"
                        placeholder={`Slide${index + 1}`}
                        ref={titleInput}
                        onChange={(e) => {
                            if (readonly) return
                            onTitleChange(index, e)
                        }}
                    />

                </p>
            </header>
            <div className="card-image px-2" onClick={() => {
                if (readonly) return
                inputFile.current.click()
            }}>
                <label className="is-hidden">
                    <input className="file-input"
                        ref={inputFile}
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                            if (readonly) return
                            if (e.target.files[0]) {
                                const file = e.target.files[0]
                                const extension = file.name.split('.').pop();
                                const newImage = {
                                    url: URL.createObjectURL(file),
                                    file: file,
                                    s3Key: `${uuid()}.${extension}`
                                }

                                setUploaded({ ...newImage })
                                onImageChange(index, newImage)
                            }
                        }
                        } />
                </label>
                <Picture image={uploaded} compact={compact} s3IdentityId={s3IdentityId}/>

            </div>
        </div>

    )
}

const CarouselCards = ({ cards, onTitleChange, onImageChange, readonly = true, s3IdentityId }) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    React.useEffect(() => {
        const handleWindowResize = () => {
            setWindowWidth(window.innerWidth);
        }
        window.addEventListener('resize', handleWindowResize);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        }
    }, []);

    return (
        <Swiper
            lazy={true}
            loop={readonly}
            effect={windowWidth >= 650 ? 'coverflow' : ''}
            grabCursor
            allowTouchMove={readonly}
            slidesPerView={'auto'}
            centeredSlides
            freeMode={false}
            autoHeight={false}
            coverflowEffect={{
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: false,
            }}
            navigation={!readonly}
            autoplay={readonly}
            pagination={{
                clickable: false,
                type: 'fraction',
                totalClass: 'total-pagination'
            }}
            breakpoints={{
                350: {
                    slidesPerView: 1,
                    spaceBetween: 2
                } ,
                650: {
                    slidesPerView: 2,
                    spaceBetween: 2
                }                   
            }}
        >

            {cards.map((item, i) => {
                return (
                    <SwiperSlide key={i}>
                        <CarouselCard
                            title={item.title}
                            image={item.image}
                            index={i}
                            readonly={readonly}
                            s3IdentityId={s3IdentityId}
                            onTitleChange={(i, v) => {
                                onTitleChange(i, v)
                            }}
                            onImageChange={(i, f) => {
                                onImageChange(i, f)
                            }}

                        />
                    </SwiperSlide>
                )
            })}


        </Swiper>
    )
};

export default CarouselCards;